import { type ReactElement } from 'react';

const EngineIcon = (): ReactElement => (
  <svg width="21" height="15" viewBox="0 0 21 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.75 3.75C1.16421 3.75 1.5 4.08579 1.5 4.5V10.5C1.5 10.9142 1.16421 11.25 0.75 11.25C0.33579 11.25 0 10.9142 0 10.5V4.5C0 4.08579 0.33579 3.75 0.75 3.75Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.75 0.75C6.75 0.33579 7.08579 0 7.5 0H13.5C13.9142 0 14.25 0.33579 14.25 0.75C14.25 1.16421 13.9142 1.5 13.5 1.5H7.5C7.08579 1.5 6.75 1.16421 6.75 0.75Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.75 3H4.5C3.67157 3 3 3.67157 3 4.5V6.75H0.75V8.25H3V10.5C3 11.3284 3.67157 12 4.5 12H6.17007L8.4742 14.5136C8.7583 14.8235 9.1595 15 9.5799 15H14.25C15.0784 15 15.75 14.3284 15.75 13.5V11.25H16.5V12.6C16.5 13.0971 16.9029 13.5 17.4 13.5H19.3415C19.759 13.5 20.1296 13.2328 20.2616 12.8368L20.4872 12.1602C20.8268 11.1412 21 10.0741 21 9C21 7.9259 20.8268 6.8588 20.4872 5.8398L20.2616 5.16324C20.1296 4.76716 19.759 4.5 19.3415 4.5H17.4C16.9029 4.5 16.5 4.90294 16.5 5.4V6.75H15.75V4.5C15.75 3.67157 15.0784 3 14.25 3H11.25V0.75H9.75V3ZM14.25 4.5H4.5V10.5H6.33504C6.65038 10.5 6.95125 10.6324 7.16434 10.8648L9.5799 13.5H14.25V10.5075C14.25 10.0891 14.5891 9.75 15.0075 9.75H17.2425C17.6609 9.75 18 10.0891 18 10.5075V12H18.9594L19.0641 11.6859C19.3528 10.8198 19.5 9.9129 19.5 9C19.5 8.0871 19.3528 7.1802 19.0641 6.3141L18.9594 6H18V7.4925C18 7.9109 17.6609 8.25 17.2425 8.25H15.0075C14.5891 8.25 14.25 7.9109 14.25 7.4925V4.5Z"
      fill="currentColor"
    />
  </svg>
);

export default EngineIcon;
